import React from 'react'
import size from 'lodash/size'
import ContextualMenu from 'components/graph/controls/contextualMenu'
import AddNode from 'components/graph/controls/addNode'
// import AddConnectedNode from 'components/graph/controls/addConnectedNode' // hidden for now; replaced by CreateEdgeControl
import CreateEdgeControl from 'components/graph/controls/createEdgeControl'
import Directionality from 'components/graph/controls/directionality'
import Delete from 'components/graph/controls/delete'
import Edit from 'components/graph/controls/edit'
import Select from 'components/graph/controls/select'
import DeselectAll from 'components/graph/controls/deselectAll'
import Pin from 'components/graph/controls/pin'

type Focus = { id?: string; isNode: boolean; isEdge: boolean }
type Selected = { nodes: Record<string, unknown>; edges: Record<string, unknown> }
type Pinned = { nodes: Record<string, unknown> }

type GraphEditMenuProps = {
  open: boolean
  onCollapse: () => void
  onWidthChange?: ((width: number) => void) | undefined
  isCreating: boolean
  isEditing: boolean
  isFetchingAny: boolean
  focus: Focus
  selected: Selected
  pinned: Pinned
  activeNodes: string[]
  editableFocus: string[]
  editableActive: string[]
  editableActiveEdges: string[]
  objectDetailsOpen: boolean
  onAddNode: () => void
  onAddConnectedNode: () => void
  onStartCreatingEdge: () => void
  onStopCreatingEdge: () => void
  onToggleDirectionality: () => void
  onDelete: () => void
  onOpenObjectDetails: () => void
  onTogglePin: () => void
  onToggleSelect: () => void
  onDeselectAll: () => void
}

const GraphEditMenu = ({
  open,
  onCollapse,
  onWidthChange,
  isCreating,
  isEditing,
  isFetchingAny,
  focus,
  selected,
  pinned,
  activeNodes,
  editableFocus,
  editableActive,
  editableActiveEdges,
  objectDetailsOpen,
  onAddNode,
  onAddConnectedNode: _onAddConnectedNode, // unused while AddConnectedNode is hidden
  onStartCreatingEdge,
  onStopCreatingEdge,
  onToggleDirectionality,
  onDelete,
  onOpenObjectDetails,
  onTogglePin,
  onToggleSelect,
  onDeselectAll,
}: GraphEditMenuProps) => {
  return (
    <ContextualMenu open={open} onCollapse={onCollapse} onWidthChange={onWidthChange}>
      {!isFetchingAny ? (
        <AddNode isCreating={isCreating} isEditing={isEditing} createAndFocusNode={onAddNode} control="<o>" />
      ) : null}
      {/* Hidden for now: replaced by CreateEdgeControl below (same drag-to-connect behavior). */}
      {/* {focus.isNode && !isFetchingAny ? (
        <AddConnectedNode
          isCreating={isCreating}
          isEditing={isEditing}
          createNodeFromActive={onAddConnectedNode}
          disabled={!focus?.id}
          control="<n>"
        />
      ) : null} */}
      {focus.isNode && !isFetchingAny ? (
        <CreateEdgeControl
          isCreating={isCreating}
          isEditing={isEditing}
          disabled={!focus?.id}
          onStartCreating={onStartCreatingEdge}
          onStopCreating={onStopCreatingEdge}
          control="<drag>"
        />
      ) : null}
      {focus.isEdge && !isFetchingAny ? (
        <Directionality
          isCreating={isCreating}
          isEditing={isEditing}
          toggleDirectionalityActive={onToggleDirectionality}
          disabled={!editableActiveEdges.length}
          control="<d>"
        />
      ) : null}
      {editableFocus.length && !isFetchingAny ? (
        <Delete isCreating={isCreating} isEditing={isEditing} deleteActive={onDelete} disabled={editableActive.length === 0} control="<del>" />
      ) : null}
      {editableFocus.length && !objectDetailsOpen && !isFetchingAny ? (
        <Edit isCreating={isCreating} isEditing={isEditing} openObjectDetails={onOpenObjectDetails} control="<enter>" />
      ) : null}
      {editableFocus.length ? (
        <Select isCreating={isCreating} isEditing={isEditing} toggleSelectFocus={onToggleSelect} selected={selected} focus={focus} control="<space>" />
      ) : null}
      {size(selected.nodes) > 0 || size(selected.edges) > 0 ? (
        <DeselectAll isCreating={isCreating} isEditing={isEditing} deselectAll={onDeselectAll} control="<esc>" />
      ) : null}
      {focus.isNode ? (
        <Pin isCreating={isCreating} isEditing={isEditing} togglePinActive={onTogglePin} pinned={pinned} activeNodes={activeNodes} control="<p>" />
      ) : null}
    </ContextualMenu>
  )
}

export default GraphEditMenu
